import { sanctioned_individual } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const findSanctions =
  ({ token, url: { service: baseURL } }: IAPI) =>
  (
    request: sanctioned_individual.FindSactionsRequest,
  ): Promise<sanctioned_individual.FindSactionsResponse> => {
    return send({
      baseURL,
      token,
      path: '/sanctioned-individual',
      method: 'GET',
      searchParams: request,
    });
  };
